import { useState, useRef, useEffect } from 'react';
import Tooltip from '../../common/Tooltip';

function toSafeString(v) {
  if (v == null) return '';
  if (typeof v === 'object') return '';
  return String(v);
}

export default function TextCell({ value, onChange, readOnly = false }) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(toSafeString(value));
  const inputRef = useRef(null);

  useEffect(() => { setText(toSafeString(value)); }, [value]);
  useEffect(() => {
    if (editing && inputRef.current) { inputRef.current.focus(); inputRef.current.select(); }
  }, [editing]);

  const save = () => {
    setEditing(false);
    const trimmed = toSafeString(text).trim();
    if (trimmed !== toSafeString(value).trim()) onChange(trimmed || null);
  };

  if (editing && !readOnly) {
    return (
      <input
        ref={inputRef}
        value={toSafeString(text)}
        onChange={(e) => setText(e.target.value)}
        onBlur={save}
        onKeyDown={(e) => {
          if (e.key === 'Enter') save();
          if (e.key === 'Escape') { setText(toSafeString(value)); setEditing(false); }
        }}
        className="w-full h-full bg-transparent border-none outline-none text-text-primary text-sm px-2"
      />
    );
  }

  const display = toSafeString(value);

  return (
    <Tooltip content={display || null} className="block w-full h-full">
      <div
        onClick={() => { if (!readOnly) setEditing(true); }}
        className={`w-full h-full flex items-center px-2 text-sm text-text-primary truncate transition-colors min-h-[40px] ${readOnly ? '' : 'cursor-pointer hover:bg-white/5'}`}
      >
        {display || <span />}
      </div>
    </Tooltip>
  );
}
